import PanelNew from '@/containers/SubscriptionFormPageNew/Panel/PanelNew'
import logo from './logo.svg'
import ZohoMcpUnlocker from './ZohoMcpUnlocker'
import useZoho from './useZoho'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import ZohoClientDataImporter from '../../../SubscriptionFormPage/ModulesPanel/Modules/CustomerModule/Fields/ZohoClientDataImporter'
import ZohoLink from './ZohoLink'
import useZohoEventListener from './useZohoEventListener'

const ZohoId = () => {
  const { formIsLoaded, isImporting, isEditable, importZohoClientData, zohoId, t, isValidZohoId, isMcpLocked } =
    useZoho()

  useZohoEventListener()

  if (!formIsLoaded) {
    return null
  }

  return (
    <PanelNew
      alt={t('subscriptionForm:zoho_module.module_title')}
      logo={logo}
      title={t('subscriptionForm:zoho_module.module_title')}
      id='ZohoModule'
    >
      <SDInput
        id='zoho-module-input'
        label={' <span style="color:red">*</span> ' + t('subscriptionForm:zoho_module.module_title')}
        currentValue={zohoId}
        placeholder={t('subscriptionForm:zoho_module.module_title')}
        disabled={true}
        status={isValidZohoId ? 'valid' : 'error'}
      />
      <ZohoLink hidden={!isValidZohoId} zohoId={zohoId} t={t} />
      <ZohoClientDataImporter
        fetchZohoClient={importZohoClientData}
        disabled={isEditable === false}
        isImporting={isImporting}
        hidden={!isValidZohoId || isMcpLocked}
      />
      <ZohoMcpUnlocker />
    </PanelNew>
  )
}

export default ZohoId
